import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { authRoutes, protectedRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login";
import { Helmet } from "react-helmet-async";
import ProtectedRoute from "./ProtectedRoute";
 
const ALLRoutes: React.FC = () => {
  const location = useLocation();
 
  const allRoutes = [...authRoutes, ...publicRoutes];
  const currentRoute = allRoutes.find((route) => route.path === location.pathname);
 
  const fullTitle = currentRoute?.title
    ? `eRoyal - CRMS | ${currentRoute.title}`
    : "eRoyal - CRMS";
 
  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);
 
  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
      </Helmet>
 
      <Routes>
        {/* ✅ Auth Routes – Login, Forgot Password, etc. */}
        {authRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}

        {/* ✅ Protected App Routes – Require Auth + Roles */}
        <Route element={<ProtectedRoute allowedRoles={["superadmin", "admin", "user"]} />}>
          <Route element={<Feature />}>
            {protectedRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </Route>
      </Routes>

    </>
  );
};
 
export default ALLRoutes;